module.exports = __webpack_public_path__ + "media/rental-protection.c3d80482.svg";